import axios from 'axios';
import { API_BASE_URL, getUserMarket } from '../config';

// Create axios instance with base configuration
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API service that matches your FastAPI backend
export const teaAPI = {
  // Get all ingredients
  getIngredients: async (inStockOnly = false, customBlendOnly = false) => {
    const response = await api.get('/api/ingredients', {
      params: { 
        in_stock_only: inStockOnly,
        custom_blend_only: customBlendOnly,
        market: getUserMarket()
      }
    });
    return response.data;
  },

  // Get single ingredient
  getIngredient: async (ingredientId) => {
    const response = await api.get(`/api/ingredients/${ingredientId}`, {
      params: { market: getUserMarket() },
    });
    return response.data;
  },

  // Evaluate custom blend
  // ``mode`` is "auto" (engine picks proportions) or "user_ratios" (customer
  // picks the percentages themselves). When mode is "user_ratios",
  // ``customPercentages`` is required: { ingredient_id: percent } summing to
  // exactly 100. The response includes ``custom_percentages`` for both modes —
  // the auto-mode echo is what seeds the "Choose my ratios" inputs.
  evaluateBlend: async (
    ingredients,
    packetSize,
    preparationMethod = 'water',
    signal = undefined,
    { mode = 'auto', customPercentages = null } = {},
  ) => {
    const payload = {
      ingredients,
      packet_size: packetSize,
      preparation_method: preparationMethod,
      market: getUserMarket(),
      mode,
    };
    if (mode === 'user_ratios') {
      payload.custom_percentages = customPercentages || {};
    }
    const response = await api.post('/api/blends/evaluate', payload, { signal });
    return response.data;
  },

  // Get all recipes (requires admin auth on API; params match OpenAPI)
  getRecipes: async (purpose = null) => {
    const response = await api.get('/api/recipes', {
      params: purpose ? { purpose } : {},
    });
    return response.data;
  },

  // Get single recipe
  getRecipe: async (recipeId) => {
    const response = await api.get(`/api/recipes/${recipeId}`);
    return response.data;
  },

  // Health check
  healthCheck: async () => {
    const response = await api.get('/api/health');
    return response.data;
  },

  // Get blend history (past orders)
  getBlendHistory: async (limit = 20, offset = 0) => {
    const response = await api.get('/api/customer/blends', {
      params: { limit, offset }
    });
    return response.data;
  },

  // Get specific blend details
  getBlendDetails: async (blendId) => {
    const response = await api.get(`/api/customer/blends/${blendId}`);
    return response.data;
  }
};

export default teaAPI;
